<template>
	<div class="wrap">
		<div class="info-li" v-for="(item, index) in noticeList" :key="index">
			<div class="info-li-top" @click="jumpUrl(item)">{{ item.news_title_name }}</div>
			<div class="info-li-bottom">
				<div class="li-bottom-left">
					{{ item.publish_datetime }}发布
					<span>{{ item.look_cnt }}人阅读</span>
				</div>
				<div class="li-bottom-right" v-if="item.is_top === '1'">
					<img src="../../assets/top.png" alt="" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { apiGetNewsList } from '../../api/api';
	export default {
		name: 'Information',
		data() {
			return {
				noticeList: [],
			};
		},
		mounted() {
			apiGetNewsList().then(res => {
				console.log(res);
				if (res.code === 200) {
					console.log(res.rows);
					this.noticeList = res.rows;
				}
			});
		},
		methods: {
			jumpUrl(item) {
				window.open(item.h5_url);
			},
		},
	};
</script>
<style scoped>
	.wrap {
		max-width: 1240px;
		margin: auto;
		margin-top: 30px;
		margin-bottom: 64px;
	}
	.info-li {
		width: 100%;
		border-radius: 12px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
		padding: 15px 26px;
		box-sizing: border-box;
		margin-bottom: 20px;
	}
	.info-li-top {
		font-size: 18px;
		font-weight: 500;
		line-height: 40.54px;
		color: rgba(66, 66, 66, 1);
		margin-bottom: 20px;
		cursor: pointer;
	}
	.info-li-bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	.li-bottom-left {
		font-size: 16px;
		font-weight: 400;
		line-height: 26.06px;
		color: rgba(66, 66, 66, 1);
	}
	.li-bottom-left span {
		color: rgba(255, 158, 116, 1);
		margin-left: 17px;
	}
	.li-bottom-right {
		width: 26.17px;
		height: 26.17px;
	}
	.li-bottom-right img {
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/information/information.vue